import React, {Fragment, useState, useEffect} from 'react';

import Formulario from './components/Formulario';
import Cita from './components/Cita';

function App() {

	//Citas en localstorage
	let citasIniciales = JSON.parse(localStorage.getItem('citas'));

	if(!citasIniciales){
		citasIniciales = [];
	}

	//Array de citas
	var [citas, guardarCitas] = useState(citasIniciales);

	//Use Effect para realizar ciertas operaciones cuando el state cambia
	useEffect( () => {
		if(citasIniciales){
			localStorage.setItem('citas', JSON.stringify(citas));
		}else{
			localStorage.setItem('citas', JSON.stringify([]));
		}
	}, [citas, citasIniciales]);

	// Funcion que tome las citas actuales y añada la nueva
	var crearCita = cita => {
		guardarCitas([
			...citas,
			cita
		]);
	}

	//Funcion que elimina una cita por su ID
	const eliminarCita = id => {
		const nuevasCitas = citas.filter(cita => cita.id !== id );
		guardarCitas(nuevasCitas);
	}


	//Mensaje condicional
	const titulo = citas.length <= 0 ? "No hay citas" : "Administra tus citas";

	return (
		<Fragment>
			<h1>Administrador Pacientes</h1>
			<div className="container">
				<div className="row">
					<div className="one-half column">
						<Formulario
							crearCita={crearCita}
						></Formulario>
					</div>
					<div className="one-half column">
						<h2>{titulo}</h2>
						
						{citas.map( element => (
							<Cita
								key={element.id}
								cita={element}
								eliminarCita = {eliminarCita}
							></Cita>
						))}
					</div>
				</div>
			</div>
		</Fragment>
	);
}

export default App;
